import ExitIntent from './logic/exit-intent';
import QuestionnaireDefs from './logic/questionnaire-defs';

const FeatureList = [
    {
        name: 'exit-intent',
        logic: ExitIntent
    },
    {
        name: 'questionnaire-defs',
        logic: QuestionnaireDefs
    }
];

export default FeatureList;
